import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {BookIcon} from '@/components/common/icons/tm-academy/BookIcon'
import {Link} from '@/i18n'
import {HOVER_TRANSITION} from '@/theme/cssTransitions'
import {theme} from '@/theme/theme'

type TopicCardProps = {
  linkHref: string
  title: string
  description?: string
  isCentered?: boolean
}

export const TopicCard: FC<React.PropsWithChildren<TopicCardProps>> = ({
  linkHref,
  title,
  description,
  isCentered = false,
}) => (
  <>
    <Link href={linkHref} legacyBehavior>
      <a className="card">
        <BookIcon />
        <div className="title">
          <Text variant={TextVariant.h6} element="h3" fontWeight={TextFontWeight.bold}>
            {title}
          </Text>
        </div>
        {description && (
          <div className="description">
            <Text variant={TextVariant.text14} color={theme.palette.text.light}>
              {description}
            </Text>
          </div>
        )}
      </a>
    </Link>

    <style jsx>{`
      .card {
        display: flex;
        flex-direction: column;
        justify-content: ${isCentered ? 'space-between' : 'flex-start'};
        width: 100%;
        height: 100%;
        padding: ${theme.spacing[4]};
        text-align: left;
        box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[200]};
        border-radius: 12px;
        transition: box-shadow ${HOVER_TRANSITION}ms ease-in-out;
      }

      .card:hover,
      .card:focus {
        box-shadow: inset 0px 0px 0px 1px ${theme.palette.gray[300]};
      }

      .title {
        margin-top: ${theme.spacing[4]};
      }

      .description {
        height: 60px;
        margin-top: ${theme.spacing[3]};
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }
    `}</style>
  </>
)
